import React, { ReactNode } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

interface AuthProviderProps {
    children: ReactNode;
}

const config = {
    domain: process.env.pnp-stg-eus2.us.auth0.com || '',
    clientId: process.env.OyxOmvDGUbxuwX3wIFlYbdPpCOB07C0M || '',
    audience: process.env.https://pharma-navigator.com || '',
    connection: process.env.Username-Password-Authentication || '',
};

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    return (
        <Auth0Provider
            domain={config.domain}
            clientId={config.clientId}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: config.audience,
                scope: 'openid profile email offline_access',
                connection: config.connection,
            }}
            useRefreshTokens={true}
            cacheLocation='localstorage'
        >
            {children}
        </Auth0Provider>
    );
};

export default AuthProvider;
